<!--

    Copyright (c) 2017-present, Siklu Ltd.
    All rights reserved.

-->
<form name="editForm" novalidate>
    @if (link) {
        <h6 class="mr-2 font-size-14" id="linkLength">
            Length - {{ distance | FeetConvert: historyService.logicalTopology.productUnits }}
            {{ historyService.logicalTopology.productUnits }}
        </h6>

        @if (linkLayerName) {
            <div class="form-group d-flex align-items-center mb-2">
                <div class="info-window-text-ellipsis font-size-12" id="link-layer-name" title="linkLayerName">
                    {{ linkLayerName }}
                </div>
            </div>
        }

        @if (historyService.selectedStepNumber === stepGroupEnum.LOCATIONS_AND_LOSES) {
            <div style="min-width: 160px">
                <winde-los-info-panel></winde-los-info-panel>
            </div>
        } @else if (link.getLinkType() === linkTypeEnum.LINK && !projectStateService.isAreaPlannerProject()) {
            <div style="min-width: 310px">
                <winde-link-info-panel></winde-link-info-panel>
            </div>

            @if (!linkInfoStateService.linkRadiosTypeChanged()) {
                <div
                        [ngClass]="{ 'node-device-content': !linkProducts || (linkProducts && linkProducts.length > 0) }"
                        class="position-relative font-size-12"
                >
                    @if (linkProducts && linkProducts.length > 0) {
                        <ul class="list-node-device mb-0 font-size-12">
                            <li>
                                <div
                                        *ngFor="let linkProduct of linkProducts; let nodeIndex = index"
                                        [attr.data-sui-e2e-node-index]="nodeIndex + 1"
                                        class="li-column"
                                >
                                    <winde-node-pointer
                                            [listData]="{ nodeNames: linkProduct.node.getName(), cropName: 10, placement: 'top' }"
                                            id="nodeName"
                                    ></winde-node-pointer>
                                </div>
                            </li>

                            <li>
                                <ng-container *ngFor="let linkProduct of linkProducts">
                                    <div [windeProductNameLink]="linkProduct.device.typeName" class="li-column" id="nodeProduct">
                                        {{ linkProduct.device.typeName }}
                                    </div>
                                </ng-container>
                            </li>

                            @if (devicesSupportAnIpConfiguration && !projectStateService.isPotentiallyCorruptedProject()) {
                                <li>
                                    <div *ngFor="let linkProduct of linkProducts; let i = index" class="li-column vertical-align-top">
                                        @if (historyService.isEditModeEnabled) {
                                            <input
                                                #asName="ngModel"
                                                (ngModelChange)="changeLinkAn(linkProduct, $event, asName.control)"
                                                [(ngModel)]="linkProduct.device.deviceAN"
                                                [device]="linkProduct.device"
                                                [id]="'nodeAsName_' + i"
                                                [locationName]="linkProduct.node.getName()"
                                                [name]="'nodeAsName_' + i"
                                                [ngClass]="{
                                                    'invalid-input': asName.errors?.error,
                                                    'warning-input': asName.errors?.warning
                                                }"
                                                class="form-control form-control-sm font-size-12"
                                                placeholder="Assigned name"
                                                type="text"
                                                windeAssignedNameValidator
                                            />
                                            @if (asName.errors?.error) {
                                                <span class="text-danger">
                                                    <small>{{ asName.errors?.error }}</small>
                                                </span>
                                            }
                                            @if (asName.errors?.warning) {
                                                <span class="text-warning">
                                                    <small>{{ asName.errors?.warning }}</small>
                                                </span>
                                            }
                                        } @else {
                                            {{ linkProduct.device.deviceAN }}
                                        }
                                    </div>
                                </li>
                                <li>
                                    <div *ngFor="let linkProduct of linkProducts; let i = index" class="li-column vertical-align-top">
                                        @if (linkProduct.device.isSectorBu ||
                                        linkProduct.device.ptP ||
                                        !historyService.logicalTopology.exportLinksConfig.ipLessTu) {
                                            @if (historyService.isEditModeEnabled) {
                                                <input
                                                    #ipAddr="ngModel"
                                                    (ngModelChange)="changeLinkIp(linkProduct, $event, ipAddr.control)"
                                                    [(ngModel)]="linkProduct.device.deviceIP"
                                                    [device]="linkProduct.device"
                                                    [id]="'nodeIp_' + i"
                                                    [locationName]="linkProduct.node.getName()"
                                                    [name]="'nodeIp_' + i"
                                                    [ngClass]="{
                                                        'invalid-input': ipAddr.errors?.error,
                                                        'warning-input': ipAddr.errors?.warning
                                                    }"
                                                    class="form-control form-control-sm font-size-12"
                                                    placeholder="IP address"
                                                    type="text"
                                                    windeIpAddressValidator
                                                />
                                                @if (ipAddr.errors?.error) {
                                                    <span class="text-danger">
                                                        <small>{{ ipAddr.errors?.error }}</small>
                                                    </span>
                                                }
                                                @if (ipAddr.errors?.warning) {
                                                    <span class="text-warning">
                                                        <small>{{ ipAddr.errors?.warning }}</small>
                                                    </span>
                                                }
                                            } @else {
                                                {{ linkProduct.ipData.viewValue }}
                                            }
                                        }
                                    </div>
                                </li>
                            }
                        </ul>
                    }
                </div>
            }
        }
    }
</form>
